import React from 'react'
import ESGAssessment from './components/ESGAssessment'
import './App.css'

function App() {
  return (
    <div className="app">
      <ESGAssessment />
    </div>
  )
}

export default App